import { apiClient, USERS } from '../../../shared/api';

export const fetchUsers = async () => {
  const response = await apiClient.get(USERS);

  return response.data;
};
